module.exports = __webpack_public_path__ + "static/nsf_logo-8f56f0ccdd1819015794a9d821dabf2e.png";